/**
 * Sprayou sepet kuralları (tema dışı uygulama yok; Kaching paket hediyeleriyle uyumlu).
 *
 * 1) Tutar hediyeleri: harcama (hediye olmayan satırların Kaching sonrası tutarı) 1.700 TL'yi geçince 1 kutu mendil,
 *    2.100 TL'yi geçince (ayar açıksa) 1 sprey sepete `_sprayou_hediye` özelliğiyle eklenir; eşik altına inince çıkarılır.
 *    Ücretsizliği Shopify otomatik sepet indirimleri sağlar ("Hediye mendil…", "Hediye sprey…").
 *    Güvenlik: beklenen indirim sepette görünmüyorsa hediye satırı çıkarılır (müşteri hediyeye asla para ödemez).
 * 2) Kaching hediye satırı ücretli hâle gelirse (ör. 3'lü paket 2'ye düşürüldü) çıkarılır.
 * 3) Hızlı ekleme şeridi ve "3'lü pakete geç" düğmeleri; sözleşme onayı olmadan ödeme butonu pasif.
 *
 * Değişiklikten sonra temanın sepet olayını (CartLinesUpdateEvent) yayınlar; çekmece kendini yeniler.
 */
import { CartLinesUpdateEvent, StandardEvents } from '@shopify/events';

const ayar = JSON.parse(document.getElementById('SpSepetAyar')?.textContent || '{}');
const KOK = window.Shopify?.routes?.root || '/';
const KAYNAK = 'sprayou-sepet';

const asilFetch = window.fetch.bind(window);

const kachingHediye = (satir) => String(satir.properties?.__kaching_bundles || '').includes('"gift"');
const temaHediye = (satir) => Boolean(satir.properties?._sprayou_hediye);

// İndirimi doğrulanamayan hediye kodu → o anki harcama. Harcama değişmedikçe aynı hediye tekrar eklenmez
// (eşik kenarında, hediye eklenince Kaching paket fiyatı değişip harcama eşiğin altına düşerse ekle-çıkar döngüsünü önler).
const engelli = new Map();
let calisiyor = false;
let tekrarGerek = false;
let zamanlayici;

async function sepetiAl() {
  return asilFetch(`${KOK}cart.js`, { headers: { Accept: 'application/json' } }).then((y) => y.json());
}

async function guncelle(guncellemeler) {
  return asilFetch(`${KOK}cart/update.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ updates: guncellemeler }),
  }).then((y) => y.json());
}

async function ekle(satirlar) {
  const yanit = await asilFetch(`${KOK}cart/add.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ items: satirlar }),
  });
  return yanit.json();
}

/** Çekmeceyi ve sepet simgesini yeniletir. action 'add' ise çekmece açılır. */
function yayinla(sepet, eylem = 'update') {
  const ertelenen = CartLinesUpdateEvent.createPromise();
  document.dispatchEvent(
    new CartLinesUpdateEvent({ action: eylem, context: 'cart', lines: [], promise: ertelenen.promise })
  );
  ertelenen.resolve({
    cart: CartLinesUpdateEvent.createCartFromAjaxResponse(sepet),
    detail: { items: sepet.items, itemCount: sepet.item_count, source: KAYNAK, didError: false },
  });
}

function hedefHediyeler(harcama) {
  const hedef = {};
  for (const esik of ayar.esikler || []) {
    if (!esik.acik || !esik.varyant || !esik.stokta) continue;
    if (engelli.has(esik.kod) && engelli.get(esik.kod) === harcama) continue;
    if (harcama >= esik.tutar) hedef[esik.kod] = esik;
  }
  return hedef;
}

/** Sepeti kurallara göre düzeltir. Değişiklik yaptıysa true döner. */
async function senkronEt() {
  if (calisiyor) {
    tekrarGerek = true;
    return false;
  }
  calisiyor = true;
  let degisti = false;
  try {
    for (let tur = 0; tur < 3; tur++) {
      const sepet = await sepetiAl();
      const guncellemeler = {};
      const eklenecek = [];

      // 2) Ücretli hâle gelmiş Kaching hediyeleri
      for (const s of sepet.items) {
        if (kachingHediye(s) && s.final_line_price > 0) guncellemeler[s.key] = 0;
      }

      // 1) Tutar hediyeleri
      const harcama = sepet.items
        .filter((s) => !kachingHediye(s) && !temaHediye(s))
        .reduce((t, s) => t + s.final_line_price, 0);
      const hedef = hedefHediyeler(harcama);
      const mevcut = {};
      for (const s of sepet.items) {
        if (!temaHediye(s)) continue;
        const kod = s.properties._sprayou_hediye;
        if (!hedef[kod] || mevcut[kod]) {
          guncellemeler[s.key] = 0; // gereksiz ya da fazladan hediye satırı
        } else {
          mevcut[kod] = s;
          if (s.quantity !== 1) guncellemeler[s.key] = 1;
        }
      }
      for (const kod of Object.keys(hedef)) {
        if (!mevcut[kod]) eklenecek.push({ id: hedef[kod].varyant, quantity: 1, properties: { _sprayou_hediye: kod } });
      }

      // Güvenlik: hediye satırı var ama karşılık gelen indirim sepette yoksa çıkar
      const indirimler = (sepet.cart_level_discount_applications || []).map((d) => d.title || '');
      for (const kod of Object.keys(mevcut)) {
        const esik = hedef[kod];
        const indirimVar = indirimler.some((baslik) => baslik.startsWith(esik.indirimBasligi));
        if (!indirimVar && !(mevcut[kod].key in guncellemeler)) {
          guncellemeler[mevcut[kod].key] = 0;
          engelli.set(kod, harcama);
          console.warn('[sprayou-sepet] Hediye indirimi bulunamadı, hediye çıkarıldı:', kod);
        }
      }

      if (!Object.keys(guncellemeler).length && !eklenecek.length) break;
      degisti = true;
      if (Object.keys(guncellemeler).length) await guncelle(guncellemeler);
      if (eklenecek.length) {
        const sonuc = await ekle(eklenecek);
        if (sonuc.status) {
          console.warn('[sprayou-sepet] Hediye eklenemedi:', sonuc.description || sonuc.message);
          break;
        }
      }
    }
    // Son güvenlik geçişi: indirimi olmayan tema hediyesi ve ücretli Kaching hediyesi sepette kalmasın
    const son = await sepetiAl();
    const sonIndirimler = (son.cart_level_discount_applications || []).map((d) => d.title || '');
    const temizle = {};
    for (const s of son.items) {
      if (kachingHediye(s) && s.final_line_price > 0) temizle[s.key] = 0;
      if (temaHediye(s)) {
        const esik = (ayar.esikler || []).find((e) => e.kod === s.properties._sprayou_hediye);
        if (!esik || !sonIndirimler.some((b) => b.startsWith(esik.indirimBasligi))) temizle[s.key] = 0;
      }
    }
    if (Object.keys(temizle).length) {
      await guncelle(temizle);
      degisti = true;
    }
    if (degisti) yayinla(await sepetiAl());
  } catch (hata) {
    console.warn('[sprayou-sepet] Senkron hatası', hata);
  } finally {
    calisiyor = false;
    if (tekrarGerek) {
      tekrarGerek = false;
      planla();
    }
  }
  return degisti;
}

function planla(gecikme = 350) {
  clearTimeout(zamanlayici);
  zamanlayici = setTimeout(senkronEt, gecikme);
}

/* Tema olayları: kendi yayınladıklarımız hariç her sepet değişikliğinden sonra kontrol et */
document.addEventListener(StandardEvents.cartLinesUpdate, (olay) => {
  olay.promise
    ?.then(({ detail }) => {
      if (detail?.source !== KAYNAK) planla();
    })
    .catch(() => {});
});

/* Uygulamaların (ör. Kaching) doğrudan sepet istekleri */
window.fetch = function (...argumanlar) {
  const adres = String(argumanlar[0]?.url || argumanlar[0] || '');
  const sonuc = asilFetch.apply(this, argumanlar);
  if (/\/cart\/(add|change|update|clear)(\.js)?/.test(adres)) {
    sonuc.then(() => planla(600)).catch(() => {});
  }
  return sonuc;
};

/* Düğmeler: bez ekle, 3'lü pakete geç, sözleşme onayı */
document.addEventListener('click', async (olay) => {
  const hizli = olay.target.closest('[data-sp-hizli-ekle]');
  if (hizli) {
    hizli.setAttribute('aria-busy', 'true');
    const varyant = Number(hizli.dataset.spHizliEkle);
    // Aynı ürünün ücretli satırı varsa adedini artır (ikinci satır açma)
    const mevcutSepet = await sepetiAl();
    const satir = mevcutSepet.items.find((s) => s.variant_id === varyant && !temaHediye(s) && !kachingHediye(s));
    const sonuc = satir
      ? await asilFetch(`${KOK}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: satir.key, quantity: satir.quantity + 1 }),
        }).then((y) => y.json())
      : await ekle([{ id: varyant, quantity: 1 }]);
    if (sonuc.status) {
      hizli.removeAttribute('aria-busy');
      hizli.textContent = 'Eklenemedi';
      return;
    }
    // Çekmece dışındaki düğmeler (leke rehberi, blog) çekmeceyi açsın
    const cekmecede = Boolean(hizli.closest('cart-drawer-component'));
    yayinla(await sepetiAl(), cekmecede ? 'update' : 'add');
    planla();
    if (!cekmecede) {
      const metin = hizli.textContent;
      hizli.removeAttribute('aria-busy');
      hizli.textContent = 'Sepete eklendi';
      setTimeout(() => (hizli.textContent = metin), 2500);
    }
    return;
  }

  const uclu = olay.target.closest('[data-sp-uclu-gec]');
  if (uclu) {
    uclu.setAttribute('aria-busy', 'true');
    await guncelle({ [uclu.dataset.anahtar]: 0 });
    await senkronEt();
    window.location.href = `${uclu.dataset.url}?paket=3`;
    return;
  }

  const odeme = olay.target.closest('.cart__checkout-button');
  if (odeme && !sozlesmeOnayli()) {
    olay.preventDefault();
    olay.stopPropagation();
    sozlesmeUyar();
  }
}, true);

function sozlesmeOnayli() {
  try {
    return sessionStorage.getItem('spSozlesme') === '1';
  } catch {
    return Boolean(document.querySelector('[data-sp-sozlesme-kutu]:checked'));
  }
}

function sozlesmeUyar() {
  document.querySelectorAll('[data-sp-sozlesme]').forEach((kutu) => {
    kutu.querySelector('[data-sp-sozlesme-uyari]')?.removeAttribute('hidden');
    kutu.classList.remove('is-uyar');
    void kutu.offsetWidth;
    kutu.classList.add('is-uyar');
  });
}

function sozlesmeUygula() {
  const onayli = sozlesmeOnayli();
  document.querySelectorAll('[data-sp-sozlesme-kutu]').forEach((k) => (k.checked = onayli));
  document.querySelectorAll('.cart__checkout-button').forEach((d) => d.setAttribute('aria-disabled', String(!onayli)));
  if (onayli) document.querySelectorAll('[data-sp-sozlesme-uyari]').forEach((u) => u.setAttribute('hidden', ''));
}

document.addEventListener('change', (olay) => {
  if (!olay.target.matches?.('[data-sp-sozlesme-kutu]')) return;
  try {
    sessionStorage.setItem('spSozlesme', olay.target.checked ? '1' : '0');
  } catch {}
  sozlesmeUygula();
});

/* Çekmece yeniden çizildiğinde onay durumunu geri yükle */
let cerceveIstegi = 0;
new MutationObserver(() => {
  cancelAnimationFrame(cerceveIstegi);
  cerceveIstegi = requestAnimationFrame(sozlesmeUygula);
}).observe(document.body, { childList: true, subtree: true });

/* Form gönderimi (Enter ya da başka yol) için de kontrol */
document.addEventListener('submit', (olay) => {
  const tetikleyen = olay.submitter;
  if (tetikleyen?.name === 'checkout' && !sozlesmeOnayli()) {
    olay.preventDefault();
    sozlesmeUyar();
  }
}, true);

sozlesmeUygula();
planla(800);
